<script>
import Controls from '../../components/widgets/PostControls'
import notify from '../../mixins/notify'

import Settings from './components/Settings'
import Content from './components/Content'
import Mixin from './components/Mixin.js'

import AchievementAddGQL from '../../graphql/private/Achievement/Add.gql'

export default {
  name: 'achievements__add',

  mixins: [Mixin, notify],

  components: {
    Settings,
    Content,
    Controls,
  },

  methods: {
    async onSave() {
      try {
        const res = await this.$apollo.mutate({
          mutation: AchievementAddGQL,
          variables: {
            achievement: {
              active: true,
              locale: this.locale,
              name: this.name,
              nameDescription: this.nameDescription,
              header: this.header,
              description: this.description,
              image: this.imageFile,
            },
          },
        })

        this.imageFile = null

        this.notify({
          text: 'Достижение обновлено!',
        })

        await this.$router.push({
          name: 'achievements__id',
          params: {
            id: res.data.achievementAdd,
          },
        })
      } catch (err) {
        this.notify({
          text: err.message,
          type: 'error',
        })
        throw new Error(err)
      }
    },
  },
}
</script>

<template lang="pug">
  div
    portal(to="pageTitle")
      span Добавить достижение

    v-container
      Settings(
        :languages="languages"
        :locale="locale"

        @languageChanged="onLanguageChanged"
      )

      .mt-10

      Content(
        :name="name"
        :nameDescription="nameDescription"
        :header="header"
        :description="description"
        :image="image"
        @nameChanged="onNameChanged"
        @nameDescriptionChanged="onNameDescriptionChanged"
        @headerChanged="onHeaderChanged"
        @descriptionChanged="onDescriptionChanged"
        @imageChanged="onImageChanged"
      )

      .mt-10

      Controls(
        @save="onSave"
      )
</template>
